// @core/api/endpoints/task/change_task_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChangeTaskStatusRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Change task status
 * Updates the task status and optionally adds a comment explaining the change. Status transitions may trigger workflow automations.
 */
export async function ChangeTaskStatus(
  task_id: string,
  data: ChangeTaskStatusRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/status`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
